var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkboxBtn"},[_c('el-checkbox-group',{attrs:{"size":"mini"},on:{"change":_vm.defaultChanges},model:{value:(_vm.defaul),callback:function ($$v) {_vm.defaul=$$v},expression:"defaul"}},_vm._l((_vm.list),function(item,index){return _c('el-checkbox-button',{key:index,attrs:{"label":item}},[_vm._v(_vm._s(item))])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71459b74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Denominated/checkboxBtn.vue
// module id = null
// module chunks = 